import { AnyAction } from 'redux';

interface UpdateTask {
    loading: boolean;
}

const initialState: UpdateTask = {
    loading: false,
};
export const UpdateTask = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'LOADING_UPDATE_TASK':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
